"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTitle = exports.StyledExcludeButton = exports.StyledCheckbox = exports.StyledButtonsWrapper = exports.StyledExcludeIcon = exports.StyledTreeItem = exports.StyledTree = void 0;
const ui_components_1 = require("@groupby/ui-components");
const Block_1 = __importDefault(require("@mui/icons-material/Block"));
const lab_1 = require("@mui/lab");
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledTree = (0, styled_components_1.default)(lab_1.TreeView) `
  overflow: auto;
  max-height: ${({ listExpanded, theme: { spacing }, productsCount }) => (listExpanded ? (productsCount > 6 ? spacing(31.25) : spacing(55.625)) : spacing(66))};
  background-color: ${ui_components_1.baseColors.background000};

  .MuiTreeItem-label {
    padding: ${({ theme }) => theme.spacing(0.625)};
    font-size: 0.875rem;
  }

  li.root-parent > div .node-title {
    font-size: ${({ theme }) => theme.spacing(2)};
    text-transform: uppercase;
    color: ${ui_components_1.baseColors.primaryGreen300};
  }
`;
exports.StyledTreeItem = (0, styled_components_1.default)(lab_1.TreeItem) `
  &.terminal-node {
    pointer-events: none;
  }

  .MuiTreeItem-group {
    margin-left: ${({ theme }) => theme.spacing(2)};
    padding-left: ${({ theme }) => theme.spacing(2)};
    border-left: ${({ theme }) => theme.typography.pxToRem(1)} solid ${ui_components_1.baseColors.primaryBlueMed100};
  }

  .MuiTreeItem-iconContainer {
    pointer-events: auto;

    svg {
      font-size: ${({ theme }) => theme.spacing(3.5)};
    }
  }

  .MuiTreeItem-label {
    display: flex;
    white-space: nowrap;
    gap: ${({ theme }) => theme.spacing(1)};

    .MuiTypography-body1 {
      font-size:  ${({ theme }) => theme.spacing(1.5)};
    }
  }

  .Mui-selected .MuiTreeItem-content {
    background-color: transparent;
  }
`;
exports.StyledExcludeIcon = (0, styled_components_1.default)(Block_1.default) `
  color: ${(props) => (props.$checked ? ui_components_1.baseColors.red : ui_components_1.baseColors.black)};
  cursor: pointer;
`;
exports.StyledButtonsWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  pointer-events: auto;
`;
exports.StyledCheckbox = (0, styled_components_1.default)(ui_components_1.Checkbox) `
  &&& {
    margin: 0;
    padding: 2px;
  }
`;
exports.StyledExcludeButton = (0, styled_components_1.default)(IconButton_1.default) `
  padding: 4px;
  color: transparent;
`;
exports.StyledTitle = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
`;
